import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const JerseyStrokeIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 26 24"
        >
            <path
                className={fillStyles}
                d="M21.186 10.541V8.575l1.219-2.329 1.482 3.779-2.701.516zM19.139 20c0 1.103-.918 2-2.046 2H8.907c-1.129 0-2.047-.897-2.047-2V8.333c0-.012-.007-.022-.007-.034-.002-.067-.024-.13-.041-.196-.016-.065-.026-.131-.054-.19-.005-.011-.004-.024-.01-.035L4.702 3.967c-.015-.028-.042-.045-.059-.071.141-.138.306-.258.437-.3l3.645-1.161 3.483 3.647c.202.211.475.318.749.318.014 0 .028-.007.043-.008.014.001.028.008.043.008.273 0 .546-.107.748-.318l3.483-3.647 3.645 1.161c.132.042.296.162.437.3-.017.026-.043.043-.058.071l-2.047 3.911c-.005.011-.004.024-.009.035-.029.059-.039.125-.055.19-.016.066-.038.129-.04.196-.001.012-.008.022-.008.034V20zM2.112 10.025l1.483-3.779 1.218 2.329v1.966l-2.701-.516zM13 3.979 11.11 2h3.78L13 3.979zm12.868 5.507-2.337-5.955c-.313-.8-1.146-1.572-1.978-1.836L17.36.359A8.848 8.848 0 0 0 15.046 0h-4.093C9.765 0 9.581.059 9.474.093L4.447 1.695c-.833.264-1.665 1.036-1.979 1.836L.132 9.485c-.205.522-.17 1.09.096 1.559.265.47.739.8 1.301.907l3.284.628V20c0 2.206 1.836 4 4.094 4h8.186c2.257 0 4.093-1.794 4.093-4v-7.421l3.285-.628a1.884 1.884 0 0 0 1.301-.907 1.805 1.805 0 0 0 .096-1.558z"
            />
        </svg>
    );
};
